exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vdp-datepicker input {\r\n    font-size: 1.4rem;\r\n    font-weight: 400;\r\n    line-height: 1.4;\r\n\r\n    display: block;\r\n\r\n    max-width: 200px;\r\n    height: calc(1.4em + 1.3rem + 2px);\r\n    padding: 0.65rem 1rem;\r\n\r\n    color: #495057;\r\n    border: 1px solid #CED4DA;\r\n    border-radius: 0.25rem;\r\n    background-color: #FFFFFF;\r\n    background-clip: padding-box;\n}\n.vdp-datepicker {\r\n    display: inline-block;\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n", ""]);

// exports
